import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-section">
                        <h3 className="footer-logo">
                            <span className="logo-text">Apps</span>
                            <span className="logo-text-accent">logie</span>
                        </h3>
                        <p className="footer-description">
                            Building innovative mobile applications that make life easier.
                        </p>
                    </div>

                    <div className="footer-section">
                        <h4>Quick Links</h4>
                        <div className="footer-links">
                            <Link to="/">Home</Link>
                            <a href="#apps">Our Apps</a>
                            <Link to="/contact">Contact Us</Link>
                            <Link to="/privacy">Privacy Policy</Link>
                            <Link to="/terms">Terms & Conditions</Link>
                            <Link to="/terms-and-conditions-of-service">Terms of Service</Link>
                            <Link to="/subscription-terms">Subscription Terms</Link>
                        </div>
                    </div>

                    <div className="footer-section">
                        <h4>Contact</h4>
                        <div className="footer-links">
                            <a href="mailto:admin@funzoftapps.com">admin@funzoftapps.com</a>
                            <p>Building the future, one app at a time.</p>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {currentYear} Appslogie. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
